export default __webpack_public_path__ + "static/media/WStore_HotPicks.cf2e4268.png";